const typographyConfig = {
  en: {
    scale: 1,
    lineHeight: 1.15,
    fontWeight: 400,
    fontFamily: `
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      sans-serif
    `,
  },

  hy: {
    scale: 0.92,
    lineHeight: 1.15,
    fontWeight: 400,
    fontFamily: `
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      sans-serif
    `,
  },
};

const getTypographyConfig = (language) =>
  typographyConfig[language] || typographyConfig.en;

export default getTypographyConfig;
